import { createSelector } from 'reselect';
import { map, get, compact, uniq } from 'lodash';

import { getCurrentAppointment } from 'modules/appointmentInfo/selectors/currentAppointment';

export const getServicesIds = createSelector(
  state => state.queues.schedule.appointments.entities,
  getCurrentAppointment,
  (appointments, currentAppointment) => {
    const Ids = [];
    if (get(currentAppointment, 'service.serviceId')) Ids.push(currentAppointment.service.serviceId);

    map(appointments, appointment => Ids.push(get(appointment, 'service.serviceId')));

    return uniq(compact(Ids));
  },
);
